export const visit = (vm, at) => {
at({ "en": { "conversations-thread-view": { "plugins-expand-communicator": { "expandEmailCommunicatorTooltip": "Expand email editor" } } } });
};